// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2rLIq","row":"Node_row__3NDih","label":"Node_label__2_8rY","footer":"Node_footer__2GhvW"};